import { recursiveTransform } from '@src/utils/magento'
import { client } from '../client'

const STORE_URL = '/V1/sales-portal/store'

export const stores = {
	getById: (id) => client.get({ url: `${STORE_URL}/${id}` }).then(recursiveTransform),
}
